<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card>
                <v-list two-line>
                    <template v-for="(reportKind, index) in reportKinds">
                        <v-list-tile
                                :key="reportKind.title"
                                avatar
                                ripple
                                @click="navigateTo(reportKind.routeName)"
                        >
                            <v-list-tile-avatar>
                                <v-icon>trending_up</v-icon>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title>{{ reportKind.title }}</v-list-tile-title>
                            </v-list-tile-content>

                        </v-list-tile>
                        <v-divider
                                v-if="index + 1 < reportKinds.length"
                                :key="index"
                        ></v-divider>
                    </template>
                </v-list>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>

    export default {
        data() {
            return {
                reportKinds: [{
                        title: 'Test History',
                        routeName: 'test-history-chart',
                    },
                    {
                        title: 'Class History',
                        routeName: 'class-history-chart'
                    }]
            }
        },

        methods: {
            navigateTo(routeName) {
                this.$router.push({name: routeName})
            }
        },
    }
</script>
